import {createReducer} from "typesafe-actions";
import {LiveOrLineType} from "../types";
import {RETURN_FROM_RESULT, SET_RESULT_TAB} from "../actions";

const init = "LIVE_AND_FINISHED";
export const selectResultTab = createReducer<LiveOrLineType>(init)
    .handleAction(SET_RESULT_TAB, (state, action) => action.payload)
    .handleAction(RETURN_FROM_RESULT, () => init);